import {ChecklistIcon} from '@primer/octicons-react'
import {MarkdownRenderer} from '@github-ui/copilot-markdown'
import styles from './DismissedPlanDisplay.module.css'

interface DismissedPlanDisplayProps {
  /** The plan markdown content to render read-only */
  planContent: string
}

export function DismissedPlanDisplay({planContent}: DismissedPlanDisplayProps) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <ChecklistIcon size={16} />
        Plan dismissed
      </div>
      <div className={styles.bordered}>
        <div className={styles.content}>
          <MarkdownRenderer markdown={planContent} />
        </div>
      </div>
    </div>
  )
}
